// This is for the custom header layout IF the theme is set to transparent header
// Requires the following in css root: --header-background-height: var(--header-height-custom-adjust) !important;
class HeaderHeight {
    constructor() {
        this.siteHeader = document.querySelector('.site-header--custom-layout');
        this.headerLogo = document.querySelector('.site-header--custom-layout .logo');
        this.nav = document.querySelector('.site-header--custom-layout .nav');
        this.mobileMenu = document.querySelector('.site-header--custom-layout .mobile-menu');
        this.mobileMenuBtn = document.querySelector('.site-header--custom-layout .mobile-menu__button--burger');
        this.init();
    }

    init() {
        if (!this.siteHeader) return;
        this.observeClassChanges();
        this.updateHeaderHeights();
        window.addEventListener('resize', this.updateHeaderHeights.bind(this));
    }

    observeClassChanges() {
        const observer = new MutationObserver(() => {
            this.updateHeaderHeights();
        });
        observer.observe(this.siteHeader, { attributes: true, attributeFilter: ['class'] });
    }

    updateHeaderHeights() {
        const headerHeight = this.siteHeader.offsetHeight;
        document.documentElement.style.setProperty('--header-height-custom-adjust', `${headerHeight}px`);
        // document.documentElement.style.setProperty('--header-background-height', `${headerHeight}px`);
    }

}

document.addEventListener('shopify:section:load', () => {
    new HeaderHeight();
});
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.site-header--custom-layout')) {
        new HeaderHeight();
    }
});

// Quick buy add to cart
const prodGridATC = () => {
    const prodGridItems = document.querySelectorAll('.product-grid-item');
  
    prodGridItems.forEach(item => {
      let form = item.querySelector('.form');
      let btnCtr = item.querySelector('.product__submit__item');
      let atcBtn = item.querySelector('.btn--quick-add');
      let options = item.querySelectorAll('input[type="radio"]');
      let variantsCtr = item.querySelector('.product-grid-item__quick-atc--variants');
  
      function expand() {
        atcBtn.classList.remove('btn--disabled');
        variantsCtr.classList.add('expand-options');
      }
  
      function collapse() {
        atcBtn.classList.add('btn--disabled');
        variantsCtr.classList.remove('expand-options');
      }
  
      if(btnCtr && atcBtn) {
        btnCtr.addEventListener('click', () => {
          expand();
        })
  
        form.addEventListener('mouseover', () => {
          expand();
        })
  
        atcBtn.addEventListener('click', () => {
          collapse()
        })
        
        form.addEventListener('mouseout', () => {
          collapse()
        })
      }
    
    })
  }
  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.product-grid-item')) {
        prodGridATC();
    }
  });

  // Drop down menu
  class ExpandFilterMenu {
    constructor() {
        this.filterDropdowns = document.querySelectorAll('.dropdown-ctr');
        this.activeMenu = null;
        this.init();
    }

    init() {
        if (this.filterDropdowns.length === 0) return;
        this.bindEvents();
    }

    bindEvents() {
        this.filterDropdowns.forEach(dropdown => {
            const btn = dropdown.querySelector('[data-dropdown-toggle]');
            const filterMenu = dropdown.querySelector('.dropdown-content');
            const downArrow = dropdown.querySelector('.icon-down-triangle');
            const dropdownTitle = dropdown.querySelector('.dropdown__label--title');
            const options = dropdown.querySelectorAll('.option--title');

            if (btn && filterMenu) {
                btn.addEventListener('click', (event) => this.toggleMenu(event, filterMenu, downArrow, options, dropdownTitle, dropdown));
            }
        });
        document.addEventListener('click', (event) => this.handleOutsideClick(event));
    }

    toggleMenu(event, filterMenu, downArrow, options, dropdownTitle, dropdown) {
        event.stopPropagation();
        event.preventDefault();
        if (this.activeMenu && this.activeMenu !== filterMenu) {
            this.activeMenu.classList.remove('expand-menu');
            downArrow.classList.remove('expand-menu');
            dropdown.classList.remove('expand-menu');
        }
        if (filterMenu.classList.contains('expand-menu')) {
            filterMenu.classList.remove('expand-menu');
            this.activeMenu = null;
            downArrow.classList.remove('expand-menu');
            dropdown.classList.remove('expand-menu');
        } else {
            filterMenu.classList.add('expand-menu');
            this.activeMenu = filterMenu;
            downArrow.classList.add('expand-menu');
            dropdown.classList.add('expand-menu');
        }

        options.forEach(option => {
          option.addEventListener('click', (e) => {
            dropdownTitle.innerText = e.target.innerText;
          })
        })
    }

    handleOutsideClick(event) {
        if (this.activeMenu && !event.target.closest('[data-dropdown-toggle]')) {
            this.activeMenu.classList.remove('expand-menu');
            this.activeMenu = null;

            this.filterDropdowns.forEach(dropdown => {
              dropdown.classList.remove('expand-menu');
            })

            document.querySelectorAll('.icon-down-triangle').forEach(arrow => {
              arrow.classList.remove('expand-menu');
            })
            
        }
    }
}
document.addEventListener('shopify:section:load', () => {
  new ExpandFilterMenu();
});
document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector('.section-product-trial')) {
      new ExpandFilterMenu();
  }
});

// Global height adjuster for use in multiple sections
function setHeightIngredients() {
  const parents = document.querySelectorAll('.section-height-adjuster');
  // Main global height adjuster
  parents.forEach(parent => {
      const prodGridInfos = parent.querySelectorAll('.height-item');
      let maxHeight = 0;
      prodGridInfos.forEach(item => {
          item.style.height = 'auto';
          const itemHeight = item.offsetHeight;
          if (itemHeight > maxHeight) {
              maxHeight = itemHeight + 5;
          }
      });
      prodGridInfos.forEach(item => {
          item.style.height = `${maxHeight}px`;
      });
  });

  // Product compare section height adjusters. These require more specific selectors.
  parents.forEach(parent => {
      const prodGridInfos = parent.querySelectorAll('.product__header');
      let maxHeight = 0;
      prodGridInfos.forEach(item => {
          item.style.height = 'auto';
          const itemHeight = item.offsetHeight;
          if (itemHeight > maxHeight) {
              maxHeight = itemHeight + 5;
          }
      });
      prodGridInfos.forEach(item => {
          item.style.height = `${maxHeight}px`;
      });
  });

  parents.forEach(parent => {
      const prodGridInfos = parent.querySelectorAll('.compare__row--one');
      let maxHeight = 0;
      prodGridInfos.forEach(item => {
          item.style.height = 'auto';
          const itemHeight = item.offsetHeight;
          if (itemHeight > maxHeight) {
              maxHeight = itemHeight + 5;
          }
      });
      prodGridInfos.forEach(item => {
          item.style.height = `${maxHeight}px`;
      });
  });

  parents.forEach(parent => {
      const prodGridInfos = parent.querySelectorAll('.compare__row--two');
      let maxHeight = 0;
      prodGridInfos.forEach(item => {
          item.style.height = 'auto';
          const itemHeight = item.offsetHeight;
          if (itemHeight > maxHeight) {
              maxHeight = itemHeight + 5;
          }
      });
      prodGridInfos.forEach(item => {
          item.style.height = `${maxHeight}px`;
      });
  });

  parents.forEach(parent => {
      const prodGridInfos = parent.querySelectorAll('.compare__row--three');
      let maxHeight = 0;
      prodGridInfos.forEach(item => {
          item.style.height = 'auto';
          const itemHeight = item.offsetHeight;
          if (itemHeight > maxHeight) {
              maxHeight = itemHeight + 5;
          }
      });
      prodGridInfos.forEach(item => {
          item.style.height = `${maxHeight}px`;
      });
  });

  parents.forEach(parent => {
      const prodGridInfos = parent.querySelectorAll('.compare__row--four');
      let maxHeight = 0;
      prodGridInfos.forEach(item => {
          item.style.height = 'auto';
          const itemHeight = item.offsetHeight;
          if (itemHeight > maxHeight) {
              maxHeight = itemHeight + 5;
          }
      });
      prodGridInfos.forEach(item => {
          item.style.height = `${maxHeight}px`;
      });
  });

  parents.forEach(parent => {
      const prodGridInfos = parent.querySelectorAll('.product-compare__form');
      let maxHeight = 0;
      prodGridInfos.forEach(item => {
          item.style.height = 'auto';
          const itemHeight = item.offsetHeight;
          if (itemHeight > maxHeight) {
              maxHeight = itemHeight + 5;
          }
      });
      prodGridInfos.forEach(item => {
          item.style.height = `${maxHeight}px`;
      });
  });
}
document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector('.section-height-adjuster')) {
      setHeightIngredients();
      window.addEventListener('resize', setHeightIngredients);
  }
});

// Resize event to force flickity init for product gallery slider on PDP template
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.product-single')) {
      window.dispatchEvent(new Event('resize'));
  }
});

// Wholesale pdp force quantity select
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.product-single') && theme.settings.wholeSaleCustomer === true) {
    document.querySelector('.product-single popout-select .select-popout__option.quantity-3').click();
  }

  if (document.querySelector('.collection-section') && theme.settings.wholeSaleCustomer === true) {
    document.querySelectorAll('.collection-section popout-select .select-popout__option.quantity-3').forEach(item => {
      item.click();
    });
  }
});


// Samita wholesale custom script
if (theme.settings.wholeSaleCustomer === true) {
  document.addEventListener('theme:cart:open', function() {
    window.Samita.Wholesale.initialize(true, "");
    document.querySelectorAll('.cart__item__remove').forEach(btn => {
      btn.addEventListener('click', () => {
        window.Samita.Wholesale.initialize(true, "");
      })
    })
  });
  
  document.addEventListener('theme:cart:added', async (e) => {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const wholesaleCartTotal = document.querySelector('.wholesale-cart-total');
      let cartTotal = 0;
      cart.items.forEach(item => {
        if(item.title.includes('TEST')) {
          cartTotal += item.final_price * item.quantity
        } else {
          cartTotal += (item.final_price * item.quantity) / 2 
        }
      })
      wholesaleCartTotal.innerText = '$' + (cartTotal / 100).toFixed(2)
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  });

  const wholesaleProdGridItemATC = () => {
    document.querySelectorAll('.product-grid-item [data-popout-option]').forEach(option => {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        
        const form = this.closest('[data-product-form]');
        const hiddenInput = this.closest('.select__fieldset').querySelector('[data-popout-input]');
        const toggleText = this.closest('popout-select').querySelector('[data-popout-text]');

        if (!form || !hiddenInput || !toggleText) return;
        
        hiddenInput.value = this.dataset.value;
        toggleText.textContent = this.dataset.value;
        
        const allOptions = this.closest('[data-popout-list]').querySelectorAll('[data-popout-option]');
        allOptions.forEach(opt => {
          opt.removeAttribute('aria-current');
          opt.closest('.select-popout__item').classList.remove('select-popout__item--current');
        });
        
        this.setAttribute('aria-current', 'true');
        this.closest('.select-popout__item').classList.add('select-popout__item--current');
        this.closest('popout-select').querySelector('[data-popout-toggle]').setAttribute('aria-expanded', 'false');
        
        const selectedOptions = Array.from(form.querySelectorAll('[data-single-option-selector]')).map(s => s.value);
        const productGridItem = this.closest('.product-grid-item');
        const productScript = productGridItem.querySelector('[data-product-json]');
        const samitaPrice = productGridItem.querySelector('.samitaWS-customized-price');
        const samitaMsrp = productGridItem.querySelector('.samitaWS-customized-original-price');
        
        if (productScript) {
          const variants = JSON.parse(productScript.textContent).variants;
          const variant = variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
          
          if (variant) {
            samitaPrice.innerText = `$${(variant.price / 100 / 2).toFixed(2)}`;
            samitaMsrp.innerText = `$${(variant.price / 100).toFixed(2)}`;
            form.querySelector('input[name="id"]').value = variant.id;
          }
        }
      });
    });
  };

  function waitForSamitaElements(selector, callback) {
    let timeoutId;
    let lastCount = 0;
    
    const observer = new MutationObserver((mutations, obs) => {
        const elements = document.querySelectorAll(selector);
        
        if (elements.length > lastCount) {
            lastCount = elements.length;
            clearTimeout(timeoutId);
            
            timeoutId = setTimeout(() => {
                obs.disconnect();
                callback(elements);
            }, 200);
        }
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  }
  
  waitForSamitaElements('.samitaWS-customized-price', (elements) => {
      if (document.querySelectorAll('.product-grid-item').length > 0) {
        const varaintSelectBtns = document.querySelectorAll('.wholesale-selector-wrapper .select-popout__toggle');
        varaintSelectBtns.forEach(btn => btn.removeAttribute('disabled'));

        wholesaleProdGridItemATC();
        
      }
  });
}

// Product compare section
const productCompareATC = () => {
  document.querySelectorAll('.product-compare-item [data-popout-option]').forEach(option => {
    option.addEventListener('click', function(e) {
      e.preventDefault();
      
      const form = this.closest('[data-product-form]');
      const hiddenInput = this.closest('.select__fieldset').querySelector('[data-popout-input]');
      const toggleText = this.closest('popout-select').querySelector('[data-popout-text]');

      if (!form || !hiddenInput || !toggleText) return;
      
      hiddenInput.value = this.dataset.value;
      toggleText.textContent = this.dataset.value;
      
      const allOptions = this.closest('[data-popout-list]').querySelectorAll('[data-popout-option]');
      allOptions.forEach(opt => {
        opt.removeAttribute('aria-current');
        opt.closest('.select-popout__item').classList.remove('select-popout__item--current');
      });
      
      this.setAttribute('aria-current', 'true');
      this.closest('.select-popout__item').classList.add('select-popout__item--current');
      this.closest('popout-select').querySelector('[data-popout-toggle]').setAttribute('aria-expanded', 'false');
      
      const selectedOptions = Array.from(form.querySelectorAll('[data-single-option-selector]')).map(s => s.value);
      const productCompareItem = this.closest('.product-compare-item');
      const productScript = productCompareItem.querySelector('[data-product-json]');
      
      if (productScript) {
        const variants = JSON.parse(productScript.textContent).variants;
        const variant = variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
        
        if (variant) {
          form.querySelector('input[name="id"]').value = variant.id;
        }
      }
    });
  });
};